function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.4375 7H10.0625C9.82812 7 9.64062 6.85938 9.54688 6.64844C9.45312 6.4375 9.5 6.20312 9.66406 6.03906L10.7656 4.9375C8.98438 3.57812 6.42969 3.69531 4.8125 5.3125C3.05469 7.07031 3.05469 9.92969 4.8125 11.6875C6.57031 13.4453 9.42969 13.4453 11.1875 11.6875C11.375 11.5 11.5391 11.2891 11.7031 11.0781C11.9375 10.7266 12.4062 10.6562 12.7344 10.8906C13.0859 11.125 13.1562 11.5938 12.9219 11.9219C12.7344 12.2266 12.5 12.4844 12.2422 12.7422C9.89844 15.0859 6.10156 15.0859 3.75781 12.7422C1.41406 10.3984 1.41406 6.60156 3.75781 4.25781C5.96094 2.05469 9.47656 1.91406 11.8203 3.88281L13.0391 2.66406C13.2031 2.5 13.4375 2.45312 13.6484 2.54688C13.8594 2.64062 14 2.82812 14 3.0625V6.4375C14 6.74219 13.7422 7 13.4375 7Z",
  fill: "#006CA3"
});

function SvgReset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.7bc6fff5.svg";
export { ForwardRef as ReactComponent };